<template lang="html">
  <v-card flat color="accent" >
    <p class="title text-xs-center pa-2">{{ $t('site-title') }} is currently in a <strong>Free Public Beta</strong><br>
      <span class="subheading" >Checkout our <a href="https://www.livestocktransportnation.com/load-pricing" target="_blank">Pricing Page</a> for more details</span>
    </p>
  </v-card>
</template>

<script>
export default {
  name: 'FreeBeta',
}
</script>

<style lang="css" scoped>
*{
  color:white;
}
a{
  text-decoration: underline;
}

</style>



// WEBPACK FOOTER //
// src/components/FreeBeta.vue